import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import Language from '../../types/language';

export default function useLanguage(): Language {
  return useSelector((state: RootState): Language => state.application.language);
}
